export default "__VITE_ASSET__bMi5AGIS__"